"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledComponents = require("styled-components");

var _keyframes = require("../keyframes");

function _templateObject14() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            ", " ", "\n        "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = (0, _taggedTemplateLiteral2["default"])(["", ""]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            ", " ", "\n        "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            ", "\n        "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2["default"])(["", ""]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            ", " ", "\n        "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2["default"])(["", ""]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            ", " ", "\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])(["", ""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            ", " ", "\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["", ""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            ", " ", "\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            ", " ", "\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme) {
  var palette = theme.palette,
      childCommon = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '50%'
  },
      contentWrapperAnimation = "\n            ".concat(theme.contentWrapperAnimationDuration, "\n            ").concat(theme.contentWrapperAnimationTimingFunction, "\n            ").concat(theme.contentWrapperAnimationIterationCount, "\n            ").concat(theme.contentWrapperAnimationFillMode, "\n        "),
      overlayAnimation = "\n            ".concat(theme.overlayAnimationDuration, "\n            ").concat(theme.overlayAnimationTimingFunction, "\n            ").concat(theme.overlayAnimationIterationCount, "\n            ").concat(theme.overlayAnimationFillMode, "\n        "),
      placeholderAnimation = "\n            ".concat(theme.placeholderAnimationDuration, "\n            ").concat(theme.placeholderAnimationTimingFunction, "\n            ").concat(theme.placeholderAnimationIterationCount, "\n        "),
      pulsarAnimation = "\n            ".concat(theme.pulsarAnimationDuration, "\n            ").concat(theme.pulsarAnimationTimingFunction, "\n            ").concat(theme.pulsarAnimationDelay, "\n            ").concat(theme.pulsarAnimationIterationCount, "\n        ");
  return {
    root: {
      position: 'relative',
      borderRadius: '50%',
      width: 'auto',
      height: 'auto',
      zIndex: theme.zIndexRoot
    },
    overlay: {
      width: theme.overlaySize,
      height: theme.overlaySize,
      backgroundColor: theme.overlayColor,
      position: 'absolute',
      top: theme.overlayPositionTop,
      left: theme.overlayPositionLeft,
      opacity: theme.overlayOpacity,
      borderRadius: '50%',
      transformOrigin: theme.overlayTransformOrigin
    },
    childWrapper: {
      backgroundColor: theme.wrapperBackgroundColor,
      position: 'relative',
      borderRadius: '50%'
    },
    placeholder: _objectSpread({}, childCommon, {
      backgroundColor: theme.placeholderColor,
      width: theme.placeholderSize,
      height: theme.placeholderSize
    }),
    pulsar: _objectSpread({}, childCommon, {
      backgroundColor: theme.pulsarColor,
      opacity: '0.54',
      width: theme.pulsarSize,
      height: theme.pulsarSize
    }),
    onClickInterceptor: {
      position: 'absolute',
      background: 'transparent',
      cursor: theme.onClickInterceptorCursor,
      top: '50%',
      left: '50%',
      width: '100%',
      height: '100%',
      transform: 'translate(-50%, -50%)',
      zIndex: palette.zOverlay
    },
    contentWrapperIn: (0, _styledComponents.css)(_templateObject(), theme.contentWrapperAnimationName || (0, _styledComponents.keyframes)(_templateObject2(), (0, _keyframes.getContentWrapper)(theme)), contentWrapperAnimation),
    contentWrapperOut: (0, _styledComponents.css)(_templateObject3(), theme.contentWrapperAnimationNameOut || (0, _styledComponents.keyframes)(_templateObject4(), (0, _keyframes.getContentWrapper)(theme, true)), contentWrapperAnimation),
    overlayIn: (0, _styledComponents.css)(_templateObject5(), theme.overlayAnimationName || (0, _styledComponents.keyframes)(_templateObject6(), (0, _keyframes.getOverlay)(theme)), overlayAnimation),
    overlayOut: (0, _styledComponents.css)(_templateObject7(), theme.overlayAnimationNameOut || (0, _styledComponents.keyframes)(_templateObject8(), (0, _keyframes.getOverlay)(theme, true)), overlayAnimation),
    pulsarIn: (0, _styledComponents.css)(_templateObject9(), theme.pulsarAnimationName || (0, _styledComponents.keyframes)(_templateObject10(), (0, _keyframes.getPulsar)(theme)), pulsarAnimation),
    pulsarOut: (0, _styledComponents.css)(_templateObject11(), theme.pulsarAnimationNameOut),
    placeholderIn: (0, _styledComponents.css)(_templateObject12(), theme.placeholderAnimationName || (0, _styledComponents.keyframes)(_templateObject13(), (0, _keyframes.getPlaceholder)(theme)), placeholderAnimation),
    placeholderOut: (0, _styledComponents.css)(_templateObject14(), theme.placeholderAnimationNameOut, placeholderAnimation)
  };
}